import PasswordInputs from "~/components/PasswordInputs.vue";
import mountApp from "~/utility/mountApp";

mountApp("PasswordInputs", PasswordInputs);
